import { Component } from '@angular/core';

@Component({
  selector: 'app-topbreadcrumb',
  imports: [],
  templateUrl: './topbreadcrumb.component.html',
  styleUrl: './topbreadcrumb.component.scss'
})
export class TopbreadcrumbComponent {

}
